import React from "react";
import { format } from "date-fns";
import { pl } from "date-fns/locale";
import EAButton from "../../shared/Buttons/EAButton";
import WeekHourGrid from "../../shared/WeekHourGrid";
import SwimmingLessonCard from "../SwimmingGrid/SwimmingLessonCard";
import { SwimmingLesson } from "../../../models/SwimmingScheduleData";
import "./style.scss";

interface IProps {
  columns: string[];
  visibleHours: string[];
  hasPastHours: boolean;
  onShowPastHours: () => void;
  onLessonClick: (lesson: SwimmingLesson) => void;
  findLessonsForSlot: (column: string, hour: string) => SwimmingLesson[];
  isDayColumnInRange: (dayKey: string) => boolean;
  loading?: boolean;
  firstAvailableDate?: Date | null;
  firstTimeLoading?: boolean;
  firstTimeChecked?: boolean;
  onGoToNearestDate?: () => void;
  isEmpty?: boolean;
}

const SwimmingWeeklyGrid: React.FC<IProps> = ({
  columns,
  visibleHours,
  hasPastHours,
  onShowPastHours,
  onLessonClick,
  findLessonsForSlot,
  isDayColumnInRange,
  loading = false,
  firstAvailableDate = null,
  firstTimeLoading = false,
  firstTimeChecked = false,
  onGoToNearestDate,
  isEmpty = false,
}) => {
  return (
    <WeekHourGrid
      columns={columns}
      hours={visibleHours}
      hasPastHours={hasPastHours}
      onShowPastHours={onShowPastHours}
      loading={loading}
      isEmpty={isEmpty}
      isColumnInRange={isDayColumnInRange}
      occupiesSlot={(dayKey, hour) => findLessonsForSlot(dayKey, hour).length > 0}
      renderCell={(dayKey, hour) =>
        findLessonsForSlot(dayKey, hour).map((lesson) => (
          <SwimmingLessonCard key={`${lesson.objectDb}-${lesson.objectId}`} lesson={lesson} onClick={onLessonClick} />
        ))
      }
      empty={
        <>
          <p className="swimming-weekly-grid__empty-state-text">Brak zajęć dla wybranych filtrów.</p>
          {(firstTimeLoading || firstTimeChecked) && (
            <div className="swimming-weekly-grid__empty-state-actions">
              {firstAvailableDate && firstTimeChecked && (
                <p className="swimming-weekly-grid__empty-state-hint">
                  Najbliższy dostępny termin: {format(firstAvailableDate, "d MMMM yyyy", { locale: pl })}
                </p>
              )}
              <EAButton
                title={
                  firstTimeLoading
                    ? "Szukam terminu..."
                    : firstAvailableDate
                      ? "Wyszukaj najbliższą datę"
                      : "Nie znaleziono terminów w ciągu najbliższego roku"
                }
                onClick={onGoToNearestDate ?? (() => {})}
                disabled={!firstAvailableDate || firstTimeLoading}
                loading={firstTimeLoading}
                loadingText="Szukam terminu..."
                variant="outlined"
              />
            </div>
          )}
        </>
      }
    />
  );
};

export default SwimmingWeeklyGrid;
